/**
 * 検索エンジンクローラーの User-Agent 判定（TK-069、FR-002）。
 *
 * **なぜ必要か。** FR-002 は「認証をクライアント JS のみで実装すれば、JS を実行しない
 * クローラーは素通りできる」という前提で書かれていた。この前提は Googlebot には
 * 成り立たない — Googlebot は JS を実行してレンダリング後の DOM でインデックスを
 * 判断するため、年齢認証オーバーレイをそのまま踏む。結果、全 URL が同一の
 * 「年齢確認」パネルとして観測される（2026-09-12 実測でステージページの
 * レンダリング後本文 149 字のうち 148 字が年齢確認パネルとヘッダの定型文だった。OI-016）。
 *
 * UA リストは creative-writing-tool の `src/lib/crawler.ts`（[CWT:FR]-06-07-A、
 * [CWT:TK]-1521）と**同一のものを意図的に写している**。姉妹サイト間で
 * 「どれをクローラーとみなすか」がずれると、同じ運営のサイト群で挙動が食い違う。
 * 片方を変えるときはもう片方も揃えること。
 *
 * **UA 偽装について。** 当サイトは静的配信であり、ステージ画像も静的 HTML も
 * 認証と無関係に取得できる（FR-002 / ADR-003）。UA を詐称して得られるのは
 * 「JS を無効にした場合と同じもの」に過ぎず、この判定が遮蔽を弱めることはない。
 * IP レンジによる補強検証は、意味のある遮蔽が導入された時点で初めて論点になる。
 */

/** クローラーとみなす User-Agent（CWT `src/lib/crawler.ts` と同一）。 */
export const CRAWLER_UA_RE =
  /(Googlebot|Bingbot|DuckDuckBot|Baiduspider|YandexBot|Slurp|Applebot|FacebookExternalHit|Twitterbot|LinkedInBot)/i;

/** `userAgent` が検索エンジンクローラー・リンク展開ボットのものか。 */
export function isCrawler(userAgent: string | null | undefined): boolean {
  if (!userAgent) return false;
  return CRAWLER_UA_RE.test(userAgent);
}
